import React, { useEffect, useState } from "react";
import axios from "../api/axios";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");

const fetchOrders = async () => {
  try {
    const token = localStorage.getItem("token"); // or however you store it
    const res = await axios.get(
      "admin/orders",
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    setOrders(res.data.data || res.data);

  } catch (err) {
    console.error("Failed to fetch orders", err);
  }
};


  useEffect(() => {
    fetchOrders();
  }, []);

  const handleStatusChange = async (id, newStatus) => {
    try {
      await axios.put(`/admin/orders/${id}`, { status: newStatus });
      // Update UI locally
      setOrders((prev) =>
        prev.map((order) =>
          order.id === id ? { ...order, status: newStatus } : order
        )
      );
    } catch (err) {
      console.error("Failed to update order status", err);
      alert("Failed to update status");
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "Completed":
        return "success";
      case "Processing":
        return "warning";
      case "Cancelled":
        return "danger";
      default:
        return "secondary";
    }
  };

 const filteredOrders = search.trim()
  ? orders.filter((order) =>
      (order.customer_name || order.full_name || "")
        .toLowerCase()
        .includes(search.toLowerCase())
    )
  : orders; // ✅ if search is empty, return all orders


  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <h5 className="mb-0">📦 Orders</h5>
          <input
            type="text"
            className="form-control w-25"
            placeholder="Search customer..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th>Status</th>
                  <th>Change Status</th>
                  <th>Total (₹)</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {filteredOrders.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center text-muted">
                      No orders found.
                    </td>
                  </tr>
                ) : (
                  filteredOrders.map((order) => (
                    <tr key={order.id}>
                      <td>#{order.id}</td>
                      <td>{order.customer_name || "N/A"}</td>
                      <td>
                        <span className={`badge bg-${getStatusBadge(order.status)}`}>
                          {order.status}
                        </span>
                      </td>
                      <td>
                        <select
                          className="form-select"
                          value={order.status}
                          onChange={(e) =>
                            handleStatusChange(order.id, e.target.value)
                          }
                        >
                          <option value="Processing">Processing</option>
                          <option value="Completed">Completed</option>
                          <option value="Cancelled">Cancelled</option>
                        </select>
                      </td>
                      <td>₹{order.total}</td>
                      <td>{new Date(order.created_at).toLocaleDateString()}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer text-end">
          <small className="text-muted">
            Showing {filteredOrders.length} order(s)
          </small>
        </div>
      </div>
    </div>
  );
};

export default Orders;
